import React from 'react';
import InlineEditableElement from 'Components/InlineEditableElement';
import {hoc} from 'Page/Sections/Jumbotron/Jumbotron';

class Jumbotron extends React.Component{

  render(){
    return (
      <section className="billboard">
        <div className={'wrapper ' + this.props.loadAnimation}>
          <div className={'caption ' + this.props.actionAnimation || ''}>
            <InlineEditableElement size={this.props.size} fontFamilyChanged={this.props.fontFamilyChanged.bind(this)} style={{maxWidth: '100%'}} el="div" onChange={this.props.valueChanged.bind(this)} html={this.props.section.prop('content')} inlineEditingEnabled={this.props.inlineEditingEnabled} />
          </div>
        </div>
      </section>
    );
  }

}

export default hoc(Jumbotron);
